import request from '../helpers/request';

const updateRequestStatus = async (requestId, statusId, errMsg) => {
  return await request.put(
    `/Request/status/${requestId}`,
    statusId,
    errMsg || 'Не удалось изменить статус',
    { result: 'Error' }
  );
};

export default updateRequestStatus;
